import apiClient from "./client.js";

export const uploadDraft = (agreementId, formData) =>
  apiClient
    .post(`/agreements/${agreementId}/drafts`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data.data);

export const getDrafts = (agreementId) =>
  apiClient.get(`/agreements/${agreementId}/drafts`).then((r) => r.data.data);

export const getDraftDownloadUrl = (agreementId, draftId) =>
  apiClient.get(`/agreements/${agreementId}/drafts/${draftId}/download`).then((r) => r.data.data);

export const finalizeDraft = (agreementId) =>
  apiClient.post(`/agreements/${agreementId}/finalize-draft`).then((r) => r.data.data);

export const vendorAgree = (agreementId) =>
  apiClient.post(`/agreements/${agreementId}/agree`).then((r) => r.data.data);

export const activateInternal = (agreementId) =>
  apiClient.post(`/agreements/${agreementId}/activate`).then((r) => r.data.data);
